import { Box, Button, Container, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import Footer from '../partials/Footer';
import Header from '../partials/Header';
import { useAuth0 } from "@auth0/auth0-react";
import { Route } from 'react-router-dom';
import  { Redirect } from 'react-router-dom'
import EmailIcon from '@material-ui/icons/Email';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const useStyles = makeStyles((theme) => ({
    cont: {
        fontSize : 36,
        fontWeight: 800
    },
    paper: {
        display: 'flex',
        justifyContent: 'center',
        alignContent : 'center',
        alignItems: 'center',
        width : 1000,
        height: 400,
        marginTop: 100,
        flexDirection: 'column'
    },
    box: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'

    },
    info: {
        marginTop: 20,
        fontWeight: 700,
        fontSize: 22
    },
    info1: {
        fontWeight: 700
    },
    button: {
        marginTop : 20
    },
    email: {
        display: 'flex',
        flexDirection: 'row'
    },
    email1: {
        fontWeight: 500,
        fontSize: 22,
        fontStyle: 'italic',

    }, 
    social: {
        display: 'flex',
        flexDirection: 'row'
    },
    info2: {
        fontWeight: 600,
        fontSize: 24,
        marginTop: 20
    },
    info3: {
        
        marginTop: 20
    },
   
  }));
const Logged = () => {
    const {isAuthenticated} = useAuth0();
    console.log(isAuthenticated)

    const classes = useStyles();

    // let comp;
    // let loged = (
    //     <div>
    //     <Container className = {classes.cont}>
    //         <Header/>
    //     <Paper>
    //         <Typography>
    //         Thank You For Signing In, Well inform you of the developments to the platform 
    //         </Typography>
    //     </Paper>
    //     <Footer/>
    //     </Container>
    //     </div>
    // )
    // let nolog = (
    //     <Redirect to='/'  />
    // )
    // if(isAuthenticated === true) {
    //     comp = loged
    // }else {
    //     comp = nolog
    // }
    return (
        <div className="flex flex-col min-h-screen overflow-hidden">
                <Header/>
            <main className="flex-grow">
                <Box className = {classes.box}>   
                <Paper className = {classes.paper} elevation={3}>
            <Typography className = {classes.cont}>
            Contact Us
            </Typography>
            <Box className = {classes.email}>
            <EmailIcon fontSize="large" className = {classes.info3} />
            <Typography className = {classes.info2}>
                Email
            </Typography>
            </Box>
            <Typography className = {classes.email1}>
                uninity1@gmail.com
            </Typography>
            <Typography className = {classes.info2}>
                Social
            </Typography>
            <Box className = {classes.social}>
                <a href = 'https://www.facebook.com/defenddata/'>
                <FacebookIcon fontSize="large"/>
                </a>
                <a href = 'https://twitter.com/uninity1'>
                <TwitterIcon fontSize="large"/>
                </a>
                <a href = 'https://www.linkedin.com/company/14655331/'>
                <LinkedInIcon fontSize="large"/>
                </a>
            </Box>
            </Paper>
            </Box>
                </main>
            
        <Footer/>
            
</div>
        
    );
};

export default Logged;